import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL || '';
axios.defaults.headers.common['Authorization'] = "Bearer "+ window.token;
axios.defaults.headers.post['Content-Type'] = 'Application/json';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export const api = ()=>{
 return window.axios = axios
};
export const getToken = ()=>{
    return window.token = localStorage.getItem('token')
};